import { Divider, Grid, TextField } from '@mui/material';

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { useApplicationsMutation, useApplicationsQuery } from 'api/hooks/notifications';
import { CreateButton } from 'app/components';
import DetailPage from 'app/components/DetailPage';
import Subheading from 'app/components/DetailPage/components/Subheading';
import { AlertActions } from 'app/containers/Dashboard/Alert/slice';
import { translations } from 'locales/i18n';

export const MailApplications = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [newApplicationName, setNewApplicationName] = useState('');

  const { data: applications } = useApplicationsQuery();
  const { creation } = useApplicationsMutation();

  const handleApplicationCreate = async () => {
    try {
      await creation.mutateAsync({ name: newApplicationName });
      dispatch(
        AlertActions.success(
          t(translations.pages.articleMessagesSettings.alerts.applicationSaveSuccessful())
        )
      );
    } catch (error) {
      dispatch(
        AlertActions.error(
          t(translations.pages.articleMessagesSettings.alerts.applicationSaveFailed())
        )
      );
    } finally {
      setNewApplicationName('');
    }
  };

  return (
    <DetailPage className="article-messages-settings__content">
      <Subheading
        content={t(translations.pages.articleMessagesSettings.subheadings.applications())}
      />
      <Grid container flexDirection={'column'} gap={2}>
        {applications.map(app => (
          <div key={app.id}>{`${app.name} - ${app.id}`}</div>
        ))}
        <Divider />
        <Grid container item alignItems={'center'} gap={2}>
          <TextField
            sx={{ maxWidth: '20em' }}
            size="small"
            value={newApplicationName}
            onChange={e => setNewApplicationName(e.target.value)}
          />
          <CreateButton onClick={handleApplicationCreate} />
        </Grid>
      </Grid>
    </DetailPage>
  );
};
